// extracted by mini-css-extract-plugin
export default {"main":"DigitalPrinting_main__G1FVw"};